import { DirectiveInstall } from "../../utils";
import Loading from "./src/index.js";

export default DirectiveInstall(Loading, "sj-loading");
